import { ServiceQueueMessages } from "@/messages/service-queue/service-queue.messages";

export const SERVICE_QUEUE_TABLE_COLUMNS = (messages: ServiceQueueMessages) => {
  return [
    messages.idColumn,
    messages.nameColumn,
    messages.activeColumn,
    messages.routingTypeColumn,
    messages.slaColumn,
    messages.optionsColumn,
  ];
};
